"use strict";
/* globals $r */
/* eslint no-console: 0 */
/*
 Link devtools
 Copyright (C) 2019  Ontola

 This program is free software: you can redistribute it and/or modify
 it under the terms of the GNU General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 This program is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU General Public License for more details.

 You should have received a copy of the GNU General Public License
 along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@ontologies/core");
var LinkLib = require("link-lib");
var LinkRedux = require("link-redux");
var LinkDevTools = /** @class */ (function () {
    function LinkDevTools(reactDevTools, globalName, lrs) {
        if (reactDevTools === void 0) { reactDevTools = undefined; }
        if (globalName === void 0) { globalName = 'dev'; }
        if (lrs === void 0) { lrs = window.LRS; }
        this.rDevTools = reactDevTools;
        this.globalName = globalName;
        this.lrs = lrs;
        window.__LINK_DEVTOOLS_GLOBAL_HOOK__ = {
            factory: new core_1.PlainFactory(),
            test: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return console.log.apply(console, args);
            },
            deltaProcessor: function (delta) {
                console.log('DEVTOOL LOG', delta);
                window.postMessage({
                    extension: "link-devtools",
                    type: "delta",
                    data: delta,
                }, "*");
                window.postMessage({
                    extension: "link-devtools",
                    type: "data",
                    data: lrs
                        .store
                        .store
                        .statements
                        .map(function (s) { return window.__LINK_DEVTOOLS_GLOBAL_HOOK__.factory.fromQuad(s); }),
                }, "*");
            },
        };
        this.lrs.deltaProcessors.unshift({
            flush: function () {
                return [];
            },
            queueDelta: function (delta, subjects) {
                console.log(delta, subjects);
            },
            processDelta: function (delta) {
                console.log(delta);
                window.__LINK_DEVTOOLS_GLOBAL_HOOK__.deltaProcessor(delta);
                return [];
            },
        });
    }
    Object.defineProperty(LinkDevTools.prototype, "$r", {
        get: function () {
            if (typeof $r !== 'undefined') {
                return $r;
            }
            return this.rDevTools;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Get the LRS bound to the component.
     * @param {React.Element} comp Component to get the LRS from.
     * @return {LinkedRenderStore|undefined} Resolved LinkedRenderStore if any.
     */
    LinkDevTools.prototype.getLRS = function (comp) {
        if (comp === void 0) { comp = this.$r; }
        var lrs = comp && comp.props && comp.props.lrs;
        if (typeof lrs === 'undefined') {
            console.warn('Component `lrs` prop is undefined, recovering by using global (you should still fix this)');
        }
        return lrs || window.LRS;
    };
    LinkDevTools.returnWithError = function (msg) {
        if (msg === void 0) { msg = undefined; }
        return console.error((msg ? msg + ", i" : 'I') + "s a link component selected? (check the value of `$r`)");
    };
    LinkDevTools.prototype.dataArr = function (comp) {
        if (comp === void 0) { comp = this.$r; }
        var lrs = this.getLRS(comp);
        if (typeof comp === 'undefined') {
            return console.error('No component selected in react devtools (check the value of `$r`)');
        }
        var subject;
        if (core_1.isNamedNode(comp) || core_1.isBlankNode(comp)) {
            subject = comp;
        }
        else {
            if (typeof comp.props === 'undefined') {
                return LinkDevTools.returnWithError('Object has no props');
            }
            subject = comp.props.object || comp.props.subject;
        }
        if (typeof subject === 'undefined') {
            return LinkDevTools.returnWithError('No subject or object found (check the value of `$r`)');
        }
        if (typeof subject === 'string') {
            console.debug('Normalizing passed subject into NamedNode');
            subject = core_1.default.namedNode(subject);
        }
        return lrs.tryEntity(subject);
    };
    LinkDevTools.prototype.showProp = function (func) {
        var _this = this;
        return function (comp) {
            if (comp === void 0) { comp = _this.$r; }
            if (typeof comp === 'undefined') {
                return console.error('No component selected in react devtools (check the value of `$r`)');
            }
            if (typeof comp.props === 'undefined') {
                return LinkDevTools.returnWithError('Object has no props');
            }
            if (typeof comp.props.label === 'undefined') {
                return LinkDevTools.returnWithError('Component `label` is undefined');
            }
            if (typeof comp.props.subject === 'undefined') {
                return LinkDevTools.returnWithError('Component `subject` is undefined');
            }
            var lrs = _this.getLRS(comp);
            console.debug('Using: ', comp.props.label, comp.props.subject, lrs ? 'local LRS' : 'global LRS');
            return func(comp.props.subject, comp.props.label);
        };
    };
    LinkDevTools.prototype.toObject = function (arr, denormalize) {
        if (arr === void 0) { arr = this.dataArr(); }
        if (denormalize === void 0) { denormalize = true; }
        if (!Array.isArray(arr)) {
            return console.error('Pass an array of statements to process');
        }
        if (arr.length === 0) {
            console.debug('No statements passed');
            return {};
        }
        var obj = {};
        for (var i = 0; i < arr.length; i++) {
            var cur = arr[i];
            var subj = core_1.default.toNQ(cur.subject);
            var pred = core_1.default.toNQ(cur.predicate);
            if (typeof obj[subj] === 'undefined') {
                obj[subj] = {};
            }
            if (typeof obj[subj][pred] === 'undefined') {
                obj[subj][pred] = cur.object;
            }
            else if (Array.isArray(obj[subj][pred])) {
                obj[subj][pred].push(cur.object);
            }
            else {
                obj[subj][pred] = [
                    obj[subj][pred],
                    cur.object,
                ];
            }
        }
        var allKeys = Object.keys(obj);
        if (denormalize && allKeys.length === 1) {
            console.debug('Returning single subject;', allKeys[0]);
            return obj[allKeys[0]];
        }
        return obj;
    };
    LinkDevTools.prototype.obj = function (resource) {
        var lrs = this.getLRS();
        var node = resource;
        if (typeof resource === 'number') {
            node = core_1.default.fromId(resource);
        }
        else if (typeof resource === 'string') {
            node = core_1.default.namedNode(resource);
        }
        return this.toObject(lrs.tryEntity(node));
    };
    Object.defineProperty(LinkDevTools.prototype, "data", {
        get: function () {
            return this.toObject(this.dataArr());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LinkDevTools.prototype, "getPropArr", {
        get: function () {
            return this.showProp(this.getResourceProperty);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LinkDevTools.prototype, "getPropRawArr", {
        get: function () {
            return this.showProp(this.getResourcePropertyRaw);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LinkDevTools.prototype, "getProp", {
        get: function () {
            var propVal = this.getPropArr;
            return Array.isArray(propVal) ? this.toObject(propVal) : propVal;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LinkDevTools.prototype, "getPropRaw", {
        get: function () {
            var propVal = this.getPropRawArr;
            return Array.isArray(propVal) ? this.toObject(propVal) : propVal;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LinkDevTools.prototype, "linkLib", {
        // eslint-disable-next-line class-methods-use-this
        get: function () {
            return LinkLib;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LinkDevTools.prototype, "linkRedux", {
        // eslint-disable-next-line class-methods-use-this
        get: function () {
            return LinkRedux;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LinkDevTools.prototype, "rdf", {
        // eslint-disable-next-line class-methods-use-this
        get: function () {
            return LinkLib.rdflib;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LinkDevTools.prototype, "rdfFactory", {
        get: function () {
            return core_1.default;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LinkDevTools.prototype, "createNS", {
        get: function () {
            return core_1.createNS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LinkDevTools.prototype, "test", {
        get: function () {
            return { globalFactory: core_1.globalFactory, globalSymbol: core_1.globalSymbol };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LinkDevTools.prototype, "reload", {
        get: function () {
            if (this.$r && this.$r.props) {
                if (!this.$r.props.reloadLinkedObject) {
                    return console.warn("Selected node doesn't seem to be a LinkedResourceContainer");
                }
                return this.$r.props.reloadLinkedObject();
            }
            return console.warn('No node or wrong node type selected.');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LinkDevTools.prototype, "topology", {
        get: function () {
            return this.$r.props.topology === null
                ? undefined
                : (this.$r.props.topology || this.$r.props.topologyCtx);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LinkDevTools.prototype, "propertyRenderers", {
        get: function () {
            return this.getLRS(this.$r).mapping;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LinkDevTools.prototype, "typeRenderers", {
        get: function () {
            return this.getLRS(this.$r).mapping['<http://purl.org/link-lib/typeRenderClass>'];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LinkDevTools.prototype, "help", {
        get: function () {
            function helpTableObj(method, desc) {
                return {
                    desc: desc,
                    method: method,
                };
            }
            console.warn('__DO NOT__ USE THESE METHODS IN CODE SINCE ARE FOR DEBUGGING PURPOSES ONLY.');
            console.group('Available object methods for LinkedResourceContainer');
            var LRC = [
                helpTableObj('<<static>> hasErrors', 'Returns whether the resource is considered to be in an error state'),
                helpTableObj('onError', 'Returns the component to render on error'),
                helpTableObj('onLoad', 'Returns the component to render on load'),
                helpTableObj('data', 'Returns the currently available data (real-time, so render-time data theoretically might differ).'),
                helpTableObj('obj', 'Same as data, but can be passed an argument.'),
                helpTableObj('objType', 'Returns the resolved type of the resource, defaults to the lrs value.'),
                helpTableObj('subject', 'Returns the normalized subject of the container'),
                helpTableObj('topology', 'Returns the current topology (or undefined when not present)'),
            ];
            console.table(LRC, ['method', 'desc']);
            console.groupEnd();
            console.info('Property and others are purely functional, so this module exposes additional methods which can be used to inspect those components');
            console.group("Available object methods for devTools (via `" + this.globalName + ".<attribute>`)");
            console.info('Most methods work on react-devtools object references (using value of `$r`)');
            var devTools = [
                helpTableObj('data', 'Returns the currently available data as an object (real-time, so render-time data theoretically might differ).'),
                helpTableObj('obj', 'Same as data, but can be passed an argument.'),
                helpTableObj('dataArr', 'Returns the raw currently available data (See also; `data`).'),
                helpTableObj('getResourceProperty()', "Exposes link-redux's `getResourceProperty` method (used by `Property` and `PropertyBase`)."),
                helpTableObj('getResourcePropertyRaw()', "Exposes link-redux's `getResourceProperty` method (used by `Property` and `PropertyBase`)."),
                helpTableObj('getPropArr', "Returns the component's 'object property' without using `toObject`."),
                helpTableObj('getPropRawArr', "Returns the component's 'object property' without using `toObject`."),
                helpTableObj('getProp', "Returns the component's formatted 'object property' by using `getResourceProperty`."),
                helpTableObj('getPropRaw', "Returns the component's formatted 'object property' by using `getResourcePropertyRaw`."),
                helpTableObj('help', 'Displays this help message.'),
                helpTableObj('reload', 'Reloads the currently selected LRC (if possible).'),
                helpTableObj('toObject(arr)', 'Converts an array of statements to an object.'),
                helpTableObj('topology', "Returns the current location's topology."),
                helpTableObj('types', ''),
                helpTableObj('typeRenderers', 'Returns all registered type renderers.'),
                helpTableObj('propertyRenderers', 'Returns all registered property renderers (including type renderers).'),
            ];
            console.table(devTools, ['method', 'desc']);
            console.groupEnd();
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    LinkDevTools.prototype.getResourceProperty = function (property, subject, lrs) {
        return (lrs || this.getLRS()).getResourceProperty(property, subject);
    };
    LinkDevTools.prototype.getResourcePropertyRaw = function (subject, property, lrs) {
        return (lrs || this.getLRS()).getResourcePropertyRaw(subject, property);
    };
    return LinkDevTools;
}());
exports.default = LinkDevTools;
